<template>
  <b-card
    no-body
  >
    <b-row>
      <b-col cols="8">
        <b-card-header>
          <b-card-title>
            {{ document.question }} - {{ $t('questionnaire.questionType.text') }}
          </b-card-title>
        </b-card-header>
        <b-card-body>
          <b-card-text>
            <b-card-text>
              <span>{{ totalAnswers }} {{ $t('questionnaire.answers') }}</span>
            </b-card-text>
            <b-card-text>
              <b-progress
                :value="answersPercent"
                max="100"
                height="6px"
                variant="primary"
              />
            </b-card-text>
            <b-card-text class="d-flex justify-content-between align-items-center">
              <b-avatar-group
                v-if="document.content.length > 1"
                size="32px"
              >
                <b-avatar
                  v-for="item in document.content.slice(0, MAX_AVATAR_NUMBER)"
                  :key="item.user.id"
                  variant="light-primary"
                  :text="getInitials(item.user.fullName)"
                />
              </b-avatar-group>
              <b-avatar
                v-else-if="document.content.length == 1"
                variant="light-primary"
                :text="getInitials(document.content[0].user.fullName)"
              />
              <div v-else />
              <b-button
                variant="flat-default pr-0"
                @click="handleShowUserAnswers(document.content)"
              >
                <span class="align-middle">{{ $t('questionnaire.showAnswers') }}</span>
                <feather-icon
                  icon="ChevronRightIcon"
                  class="ml-50"
                />
              </b-button>
            </b-card-text>
          </b-card-text>
        </b-card-body>
      </b-col>
      <b-col
        cols="4"
        style="border-left: 1px solid #EBE9F1"
      />
    </b-row>
  </b-card>
</template>

<script>
import {
  BCard, BCardText, BRow, BCol, BAvatar, BCardBody, VBModal,
  BCardHeader, BCardTitle, BProgress, BAvatarGroup, BButton,
} from 'bootstrap-vue'
import { getInitials } from '@hw-core/utils'

export default {
  directives: {
    'b-modal': VBModal,
  },
  components: {
    BCard,
    BCardText,
    BRow,
    BCol,
    BAvatar,
    BCardBody,
    BCardHeader,
    BCardTitle,
    BProgress,
    BAvatarGroup,
    BButton,
  },
  props: {
    document: {
      type: Object,
      default: () => {},
    },
    targetSize: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      MAX_AVATAR_NUMBER: 5,
    }
  },
  computed: {
    totalAnswers() {
      return this.document.content.length
    },
    answersPercent() {
      if (this.targetSize) {
        return ((this.totalAnswers * 100) / this.targetSize).toFixed(2)
      }
      return 0
    },
  },
  methods: {
    getInitials,
    handleShowUserAnswers(content) {
      this.$emit('show-user-answers', content)
    },
  },
}
</script>
